module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"dialog_titulo":"Detalles del material","material":"Material","precio":"Precio","dap":"Declaración ambiental:","dpres":"características técnicas:","dap_indi":"{0} (<span class=\u0027mayus\u0027>{1}</span>)","dap_val":"{0} ({1})","pres_indi":"{0}, norma: {1}","pres_val":"{0} ({1})"}}')
  delete Component.options._Ctor
}
